/** @jsxImportSource @emotion/react */
// import { css } from '@emotion/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CategoryData, getCategoriesWithCounters } from '../../data';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import PlusIcon from '../../icons/Plus';
import { Title } from '../../components/Title';
import { CategoryListTable } from '../../components/dashboard/CategoryListTable';
import { Navigate } from 'react-router-dom';
import { accountService, UserRole } from '../../account.service';

export const AdmCategoryList = () => {
    const navigate = useNavigate();
    const account = accountService.getAccount();
    const [categories, setCategories] = useState<CategoryData[]>([]);

    useEffect(() => {
        let cancelled = false;
        const doGetCategories = async () => {
            const fetchedCategories = await getCategoriesWithCounters();
            if (!cancelled) {
                setCategories(fetchedCategories);
            }
        };
        doGetCategories();
        return () => {
            cancelled = true;
        };
    }, []);

    const handleAdd = () => {
        navigate('/kb/categories/new');
    };

    return (
        <>
            {(!account || account.role !== UserRole.Admin) && <Navigate to="/account/login" />}
            <Title title="Categories" />
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 8,
                }}
            >
                <Container maxWidth={false}>
                    <Grid container justifyContent="space-between" spacing={3}>
                        <Grid item>
                            <Typography color="textPrimary" variant="h5">
                                Category List
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Box sx={{ m: -1 }}>
                                <Button
                                    color="primary"
                                    startIcon={<PlusIcon fontSize="small" />}
                                    sx={{ m: 1 }}
                                    variant="contained"
                                    onClick={handleAdd}
                                >
                                    Add Category
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 3 }}>
                        <CategoryListTable categories={categories} />
                    </Box>
                </Container>
            </Box>
        </>
    );
};
